document.addEventListener('DOMContentLoaded', () => {

	function formatNumber(number, isFinal, originalIsInteger) {
		if (originalIsInteger) return String(Math.round(number));
		if (!isFinal) return String(Math.floor(number));
		let formatted = number.toFixed(1);
		if (formatted.endsWith('.0')) return String(Math.round(number));
		return formatted.replace('.', ',');
	}

	function updateNumberFrame(element, targetNumber, animationStartTime, animationDuration, originalIsInteger) {
		const currentTime = performance.now();
		const progress = Math.min((currentTime - animationStartTime) / animationDuration, 1);
		const rawValue = targetNumber * progress;
		const isFinal = progress === 1;
		element.textContent = formatNumber(rawValue, isFinal, originalIsInteger);
		if (progress < 1) {
			requestAnimationFrame(() => updateNumberFrame(element, targetNumber, animationStartTime, animationDuration, originalIsInteger));
		}
	}

	function animateNumber(element) {
		const targetNumber = parseFloat(element.dataset.n.replace(',', '.'));
		const originalIsInteger = Number.isInteger(targetNumber);
		const animationStartTime = performance.now();
		const animationDuration = 2000;
		updateNumberFrame(element, targetNumber, animationStartTime, animationDuration, originalIsInteger);
	}

	function handleIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				animateNumber(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}

	function initializeObserver() {
		const intersectionObserver = new IntersectionObserver(handleIntersection, { threshold: 0.5 });
		document.querySelectorAll('.numbers-image__number').forEach(element => intersectionObserver.observe(element));
	}

	function initialize() {
		initializeObserver();
	}

	initialize();
});